<template>

<v-form ref="valueChainPropertiesForm" v-model="formValid">
  <div class="value-chain-properties" v-if="hasProperties">
    <div class="value-chain-properties__tree">    
      <v-treeview :items="items" activatable open-all dense @update:active="setActiveElement" item-key="id" :active="activeElements ? activeElements: undefined" color="#1b99a7" >
        <template v-slot:label="{ item, selected, active, open }">
          <div class="value-chain-properties__tree-item"> 
          
          <span class="value-chain-properties__tree-item__label">{{ item.articleNo }} ({{ $t(`VALUE-CHAIN-PROPERTIES-LEVEL-${String(item.level).toLocaleUpperCase()}`) }})</span>
          <!-- <span class="value-chain-properties__tree-item__dot" :style="`background: ${statusColor(item.status)}`"></span> -->
          <v-btn
          class="value-chain-properties__tree-item__tag"
      rounded
      :ripple="false"
      x-small
      :color="statusColor(item.status)"
    >
    {{ $t(`VALUE-CHAIN-PROPERTIES-STATUS-${item.status.toLocaleUpperCase()}`) }}
    </v-btn>
          
        </div>
      </template>
      </v-treeview>
    </div>
    <div class="value-chain-properties__content">
      <template v-if="isActive && activeContent">
      <div class="value-chain-properties__element" v-if="activeContent.shortDescription !== undefined">
        <ValueChainItem   :title="$t('VALUE-CHAIN-PROPERITES-SHORT-DESCRIPTION')"
                    :value="activeContent.shortDescription"
                    type="textarea"
                    outlined
                    hideDetails
                    rows="1"
                    labelCustomStyle="flex:0 0 200px;"
                    rowHeight="10"
                    boxItemClass="align-start"
                    @updateValue="activeContent.shortDescription = $event"/>
                    
                  </div>
                  <div class="value-chain-properties__element" v-if="activeContent.description !== undefined">
        <ValueChainItem  :title="$t('VALUE-CHAIN-PROPERITES-DESCRIPTION')"
                    :value="activeContent.description"
                    type="textarea"
                    labelCustomStyle="flex:0 0 200px;"
                    hideDetails
                    outlined
                    rows="3"
                    rowHeight="10"
                    boxItemClass="align-start"
                    @updateValue="activeContent.description = $event"/>
                    <div class="value-chain-properties__transient"></div>
                  </div>
        <template v-if="valueChainPropertiesAttributes() && valueChainPropertiesAttributes().length > 0">

          <div class="value-chain-properties__element" v-for="attr in valueChainPropertiesAttributes()" :key="attr.name">
          <ValueChainPropertiesAttribute :attribute="attr" :issues="activeContent.issues"  @updateModel="updateAttribute"/>
          </div>
        </template>          
                  
      </template>
    </div>
  </div>
  </v-form>
</template>

<script>
import {cloneDeep} from 'lodash';
import ValueChainItem from '@/components/item/ValueChainItem.vue';
import ValueChainPropertiesAttribute from './ValueChainPropertiesAttribute.vue';
  export default {
    name: 'ValueChainProperties',
    components: {ValueChainItem, ValueChainPropertiesAttribute},
    props:{
      properties: {
        type: Object,
      },
      
    },
    data(){
      return {
        activeElements: null,
        activeContent: null,
        items: [],
        isLoaded: false,
        formValid: false,
        propertiesChanged: false,
      }
    },
    computed: {
      hasProperties(){
        return this.properties && Object.entries(this.properties).length > 0;
      },
      isActive(){
        return this.activeElements && this.activeElements.length > 0;
      },
      saved(){
        return this.$store.getters.savedValueChainProperties;
      },
      reInit(){
        return this.saved && this.propertiesChanged;
      },
      initActiveElement(){
        const activeElement = this.$store.getters['showArticlePropertiesTabUnit'];
        if(!activeElement) return null;
        return activeElement;
      },
      statusColor(){
        return (status) => {
          switch(status){
            case "INVALID":{
              return "error";
            }
            case 'INACTIVE':{
              return 'warning';
            }
            case 'ACTIVE':{
              return 'success';
            }
            default:
              throw new Error(`Not supported status: ${status}`);
          }
        } 
      },      
    },
    watch:{
      activeContent:{
        handler(){ 
          if(!this.isLoaded || !this.activeElements || !this.activeContent) return;
          this.syncProperties();
        },
        deep: true
      },
      properties:{
        handler(){
          this.items = [cloneDeep(this.properties)];
          this.propertiesChanged = true;
        },
        deep: true
      },
      initActiveElement:{
        handler(value){
          if(!value) return;
          this.setActiveElement(value);
        }
      },
      reInit:{
        handler(value){
          if(!value) return;
          if(!this.activeElements) return; // skip no active element found
          const id = this.activeElements[0];
          this.init(id);
          this.$store.commit('SET_VALUE_CHAIN_SAVED', false);
          this.propertiesChanged = false;
        }
      }
    },
    mounted() {
    },
    methods: {
      valueChainPropertiesAttributes(){
        if(!this.activeContent || !this.activeContent.attributes || !this.activeContent.attributes.length) return [];
        return cloneDeep(this.activeContent.attributes);
      },
      init(activeId = 0){
        this.items = [cloneDeep(this.properties)];
        if(!activeId){
          if(this.initActiveElement){
            activeId = this.initActiveElement;
            this.$store.commit('RESET_SHOW_ARTICLE_PROPERTIES_UNIT');
          }else{
            activeId = this.properties.id;
          }
        }
        this.setActiveElement(activeId);
        this.isLoaded = true;
      },
      syncProperties(){
          if(!this.activeElements || !this.activeElements.length || !this.activeContent) return;
          const id = this.activeElements[0]; // always only can be one active element
          let syncProperties = cloneDeep(this.items[0]);
          try{

            if(syncProperties.id === id){
              syncProperties = cloneDeep(this.activeContent);
            }else if(syncProperties.children && syncProperties.children.length >0){
              const findChangedIndex = syncProperties.children.findIndex((child) => child.id === id);
              if(findChangedIndex !== -1){
                syncProperties.children.splice(findChangedIndex,1,cloneDeep(this.activeContent));
              }else{
                for (let subChildIndex = 0; subChildIndex < syncProperties.children.length; subChildIndex++) {
                  const subChild = syncProperties.children[subChildIndex];
                // for(const [subChildIndex, subChild] of syncProperties.children){
                  if(subChild && subChild.children && subChild.children.length > 0){
                    const findSubChildIndex = subChild.children.findIndex((child) => child.id === id);
                    if(findSubChildIndex !== -1){
                      syncProperties.children[subChildIndex].children.splice(findSubChildIndex, 1, cloneDeep(this.activeContent));
                    }else{
                      for (let subChild2Index = 0; subChild2Index < subChild.children.length; subChild2Index++) {
                      // for(const [subChild2Index, subChild2] of subChild.children){
                        const subChild2 = subChild.children[subChild2Index];
                        if(subChild2.children && subChild2.children.length > 0){
                          const findSubChild2Index = subChild2.children.findIndex((child) => child.id === id);
                          if(findSubChild2Index !== -1){
                            syncProperties.children[subChildIndex].children[subChild2Index].children.splice(findSubChild2Index, 1, cloneDeep(this.activeContent));
                            
                          }else{
                            for (let subChild3Index = 0; subChild3Index < subChild2.children.length; subChild3Index++) {
                              const subChild3 = subChild2.children[subChild3Index];
                            // for(const [subChild3Index, subChild3] of subChild2.children){
                              if(subChild3.children && subChild3.children.length > 0){
                                const findSubChild3Index = subChild3.children.findIndex((child) => child.id === id);
                                if(findSubChild3Index !== -1){
                                  syncProperties.children[subChildIndex].children[subChild2Index].children[subChild3Index].children.splice(findSubChild3Index, 1, cloneDeep(this.activeContent));
                                  
                                }else{
                                  // here we can add another level if needed!
                                  
                                }
                              }
                            }      
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            this.$emit('syncProperties', syncProperties);
            

        }catch(err){
            console.error(err);
        }
      },

      updateAttribute(attribute){
        const attributeIndex = this.activeContent.attributes.findIndex(el => el.name === attribute.name);
        if(attributeIndex === -1) throw new Error('Cannot find the attribute with name: '+attribute.name);
        const attributes = cloneDeep(this.activeContent.attributes);
        attributes.splice(attributeIndex, 1, cloneDeep(attribute));
        this.activeContent = Object.assign(this.activeContent, {attributes});
        this.validateForm();  
      },

      validateForm(){
        if(this.$refs.valueChainPropertiesForm){
          this.$store.commit('SET_VALUE_CHAIN_PROPERTIES_FORM_STATUS', this.$refs.valueChainPropertiesForm.validate());
        }
      },
      setActiveElement(id){
        if(Array.isArray(id)){
          id = id[0];
        }
        if(this.activeElements && this.activeElements.includes(id) && !this.reInit){
          this.activeElements = null;
          this.activeContent = null;
        }else{
          this.activeElements = [id];
          const rootElement = cloneDeep(this.items[0]);
          let foundElement = null;
          if(rootElement.id === id ){
            foundElement = cloneDeep(rootElement);
          }else if(rootElement.children && rootElement.children.length >0){
            foundElement = rootElement.children.find((child) => child.id === id);
            if(!foundElement){
              for(const el of rootElement.children){
                if(el.id === id){
                  foundElement = cloneDeep(el);
                  break;
                }
                if(el.children && el.children.length > 0){
                  for(const child of el.children){
                    if(child.id === id){
                      foundElement = cloneDeep(child);
                      break;
                    }
                    if(child.children && child.children.length > 0){
                      for(const subChild of child.children){
                        if(subChild.id === id){
                          foundElement = cloneDeep(subChild);
                          break;
                        }
                        if(subChild.children && subChild.children.length > 0){
                          for(const subChild2 of subChild.children){
                            if(subChild2.id === id){
                              foundElement = cloneDeep(subChild);
                              break;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          this.activeContent = foundElement? cloneDeep(foundElement): null;
        }
      }
      
    },
    created(){
      this.init();
      this.validateForm();
    }
  }
</script>

<style lang="scss" scoped>
.value-chain-properties{
  display: flex;
  flex-wrap: wrap;

  &__element{
    display: flex;
    flex: 0 1 470px;
      
    
  }
  &__tree{
    border: 1px solid #ccc;
    flex: 0 1 400px;
    overflow: hidden;
    @media (max-width:1200px){
        flex: 0 1 100%;
    }
    &-item{
      cursor: pointer;
      padding: .5em .1em .1em;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      &__label{
        display: block;
        max-width: 280px;
        color: #666666!important;
        font-family: Arial, sans-serif!important;
        font-weight: 400!important;
        font-size: 14px!important;
        line-height: 14px!important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &__dot{
        margin-left: 5px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
      &__tag{
        margin-left: 2px; 
        max-width: 380px;
        padding: 0 5px!important;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  &__content{
    margin-left:.5em;
    border: 1px solid #ccc;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    padding: 1em 1.5em;

    @media (max-width:1200px){
        margin-left: 0;
        margin-top: .5em;
      }
    
  }

}
</style>
